import type { Accept } from 'react-dropzone'

export const ACCEPTED_IMAGE_UPLOAD_TYPES: Accept = {
  'image/jpeg': ['.jpg', '.jpeg', '.jfif', '.jpe', '.jif', '.jfi'],
  'image/png': ['.png'],
  'image/webp': ['.webp'],
  'image/tiff': ['.tif', '.tiff'],
  'image/bmp': ['.bmp'],
  'image/gif': ['.gif'],
}

export const MAX_IMAGE_UPLOAD_FILE_SIZE = 100 * 1024 * 1024
export const MAX_IMAGE_UPLOAD_PIXELS = 400_000_000

export const getImageUploadUrl = (locale: string) => {
  const language = locale.substring(0, 2)

  return language === 'en'
    ? 'ajax/api/user/images/upload-file'
    : `ajax/${language}/api/user/images/upload-file`
}
